import ApiService from '@/services/core/api.service'

const CompanyService = {
  async get (query) {
    return ApiService.get(`admin/companies?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/companies', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/companies/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`admin/companies/${payload.id}`)
  }
}

export default CompanyService
